<template>
  <Transition>
    <span
      v-if="backend.configModified"
      class="cursor-pointer"
      @click="resetConfig"
    >
      <div class="tooltip" data-tip="Configuration modified, click to reset">
        <Icon icon="mi:undo" class="hover:scale-110" />
      </div>
    </span>
  </Transition>
</template>

<script setup lang="ts">
import { useBackendStore } from "@/stores";

const backend = useBackendStore();

const resetConfig = () => {
  if (backend.currentConfig != null)
    backend.setCurrentConfig(backend.currentConfig.id);
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  @apply transition-all duration-200;
}

.v-enter-from,
.v-leave-to {
  @apply opacity-0 scale-50;
}
</style>
